import { AbstractControl, ValidationErrors } from '@angular/forms';

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;

export function emailValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) return null;
  return EMAIL_REGEX.test(control.value) ? null : { invalidEmail: true };
}